import React from "react";
import Header4 from "./../Common/Header4";
import Footer2 from "./../Common/Footer2";
import Banner from "./../Elements/Banner";
import Projects6 from "./../Elements/Projects6";
import withRouter from "./../Common/withRouter";
import { projectDetails } from "./../../data/index";
import ProjectDetail from "./ProjectDetail";
import NotFound from "./NotFound";
class ProjectDetail1 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("/assets/js/custom.js");
  }
  render() {
    const project = projectDetails.find(
      (project) => project.id === this.props.params.projectId
    );

    return (
      <>
        <Header4 />

        <div className="page-content">
          <Banner
            title={project.title}
            pagename={project.title}
            bgimage={project.bnrImg}
          />
          {/* SECTION CONTENT START */}
          {project ? <ProjectDetail project={project} /> : <NotFound />}
          {/* SECTION CONTENT END  */}
          {
            // if subSection exist then show Projects6
            // project.subSections ? <Projects6 projects={project.subSections} /> : ''
          }
        </div>

        <Footer2 />
      </>
    );
  }
}

export default withRouter(ProjectDetail1);
